import { c as _c } from "react/compiler-runtime";
import { HotelSearchSummaryContent } from "@website/accommodation-ui/hotel-search/hotel-search-summary/hotel-search-summary-content/hotel-search-summary-content";
import { useHotelSearchSummary } from "@website/accommodation-ui/hotel-search/hotel-search-summary/hotel-search-summary.hook";
import { HotelSearchSummaryPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-summary/hotel-search-summary.types";
import { FC } from "react";
export const HotelSearchSummary: FC<HotelSearchSummaryPropertiesType> = properties => {
  const $ = _c(2);
  const viewProperties = useHotelSearchSummary(properties);
  let t0;
  if ($[0] !== viewProperties) {
    t0 = <HotelSearchSummaryContent {...viewProperties} />;
    $[0] = viewProperties;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};